import { Modal } from '@raysee/ui';
import Image from 'next/legacy/image';
import { VFC } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}
export const FirstLimitedPlanDescriptionModal: VFC<Props> = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <div className="p-4 text-sm">
      <div className="mb-4 border-b pb-2 text-lg font-bold">
        「初回限定メニュー」の返金保証オプションについて
      </div>
      <div>
        RAYSEEのチャット鑑定では、<strong>初回限定メニュー</strong>
        のうち<strong>鑑定価格が500円以下</strong>
        のものに限り、「返金保証」のオプションを選択することができます。
      </div>
      <div className="mt-4">
        返金保証対象のメニューを購入したユーザーは、鑑定終了から7日以内に指定の方法で申請することで、当該の初回限定メニューの鑑定料金を全額返金してもらうことができます。
      </div>
      <div className="mt-2 text-sm">＊返金申請はユーザーあたりサービス内で1回のみ可能です </div>
      <div className="text-sm">＊鑑定のキャンセルを申請するものではありません </div>
      <div className="mt-4">
        返金は運営によって実施され、占い師の負担はありません。鑑定料金がユーザーに返金された場合でも、占い師へは通常通りの報酬が支払われます。
      </div>
      <div className="mt-4">
        返金保証対象の鑑定メニューはユーザーサイトで以下のように表示され、ユーザーがより気軽に購入を検討しやすくなります。
      </div>
      <div className="my-4" id={'desktop_IsBackGuarantee'}>
        <Image src={'/images/desktop_IsBackGuarantee.png'} width="700" height="215" alt="" />
      </div>
      <div className="my-4" id={'mobile_IsBackGuarantee'}>
        <Image src={'/images/mobile_IsBackGuarantee.png'} width="195" height="224" alt="" />
      </div>
    </div>
  </Modal>
);
